module.exports = __webpack_public_path__ + "static/media/Marduk.33c34deb.png";